import { render } from "./AddSensorAlarmComment.vue?vue&type=template&id=6b4e36fc&scoped=true&ts=true"
import script from "./AddSensorAlarmComment.vue?vue&type=script&lang=ts"
export * from "./AddSensorAlarmComment.vue?vue&type=script&lang=ts"

import "./AddSensorAlarmComment.vue?vue&type=style&index=0&id=6b4e36fc&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b4e36fc"]])

export default __exports__